export default {
  getData(state) {
    return state.data;
  },
  getTotal(state) {
    return state.total;
  },
  getCategories(state) {
    return state.categories;
  },


  getDetail(state) {
    return state.detail;
  },

};
